module.exports = __webpack_public_path__ + "img/PLAYER2-min.06b048f9.png";